export function isFreeCourse(course) {
    const price = course?.prix;
    return price !== null && price !== undefined && String(price).trim() !== '' && Number.isFinite(Number(price)) && Number(price) === 0;
}
